import { useState } from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router";

import { Box, Typography } from "@mui/material";

import formatPageTitle from "@utils/formatPageTitle";

import { GetOverviewMetricsPeriod } from "@covertree/agent-portal-graphql";
import { MetricsFilter } from "./MetricsFilter";
import { Metrics } from "./Metrics";
import { RecentQuotes } from "./RecentQuotes";

export function Overview() {
  const [metricsPeriod, setMetricsPeriod] = useState<GetOverviewMetricsPeriod>(
    GetOverviewMetricsPeriod.Year
  );

  return (
    <>
      <Helmet>
        <title>{formatPageTitle("Overview")}</title>
      </Helmet>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h3">Overview</Typography>
        <MetricsFilter
          period={metricsPeriod}
          onPeriodChange={setMetricsPeriod}
        />
      </Box>
      <Metrics period={metricsPeriod} />
      <RecentQuotes />
      <Outlet />
    </>
  );
}
